"use client";

import * as TablerIcons from "@/lib/tabler-icons";

export const iconMap = TablerIcons;
